import React, { useEffect } from "react";
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    Typography,
    Box,
    Divider,
    useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useForm, FormProvider } from "react-hook-form";
import TextInput from "qubCommon/Inputs/TextInput";
import DateInput from "qubCommon/Inputs/DateInput";

const ProgramPeriodDialog = ({ open, onClose, onSubmit, defaultValues = {} }) => {
    const methods = useForm({
        defaultValues: {
            description: "",
            abbr: "",
            dateFrom: null,
            dateTo: null,
            decision: "",
            ...defaultValues,
        },
    });

    const { reset, handleSubmit } = methods;
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isEdit = !!defaultValues?.id;

    useEffect(() => {
        if (open) {
            reset({
                description: "",
                abbr: "",
                dateFrom: null,
                dateTo: null,
                decision: "",
                ...defaultValues,
            });
        }
    }, [defaultValues, open, reset]);

    const onSubmitForm = (data) => {
        const payload = {
            id: defaultValues?.id || null,
            description: data.description,
            abbr: data.abbr,
            dateFrom: data.dateFrom,
            dateTo: data.dateTo,
            decision: data.decision || null,
            isDeleted: false,
        };

        onSubmit(payload);
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            fullScreen={isMobile}
        >
            {/* Header */}
            <Box sx={{ backgroundColor: "#f5f8fa", px: 3, py: 2 }}>
                <Typography variant="h4" fontWeight={700} color="primary">
                    {isEdit ? "Επεξεργασία Περιόδου" : "Νέα Περίοδος"}
                </Typography>
            </Box>

            <Divider />

            <FormProvider {...methods}>
                <DialogContent sx={{ px: 3, py: 3 }}>
                    <Grid container spacing={2}>

                        {/* ✅ DESCRIPTION */}
                        <Grid item xs={12} sm={6}>
                            <TextInput
                                name="description"
                                label="Περιγραφή"
                                isFullWidth
                                rules={{
                                    required: "Η Περιγραφή είναι υποχρεωτική",
                                    maxLength: { value: 50, message: "Έως 50 χαρακτήρες" },
                                }}
                                defaultFromProps={false}
                            />
                        </Grid>

                        {/* ✅ ABBR */}
                        <Grid item xs={12} sm={6}>
                            <TextInput
                                name="abbr"
                                label="Σύντμηση"
                                isFullWidth
                                rules={{
                                    required: "Η Σύντμηση είναι υποχρεωτική",
                                    maxLength: { value: 10, message: "Έως 10 χαρακτήρες" },
                                }}
                                defaultFromProps={false}
                            />
                        </Grid>

                        {/* ✅ DATE FROM */}
                        <Grid item xs={12} sm={6}>
                            <DateInput
                                name="dateFrom"
                                label="Έναρξη"
                                isFullWidth
                                rules={{ required: "Η Έναρξη είναι υποχρεωτική" }}
                                defaultFromProps={false}
                            />
                        </Grid>

                        {/* ✅ DATE TO */}
                        <Grid item xs={12} sm={6}>
                            <DateInput
                                name="dateTo"
                                label="Λήξη"
                                isFullWidth
                                rules={{ required: "Η Λήξη είναι υποχρεωτική" }}
                                defaultFromProps={false}
                            />
                        </Grid>

                        {/* ✅ DECISION (OPTIONAL) */}
                        <Grid item xs={12}>
                            <TextInput
                                name="decision"
                                label="Υπουργική Απόφαση"
                                isFullWidth
                                rules={{
                                    maxLength: { value: 50, message: "Έως 50 χαρακτήρες" },
                                }}
                                defaultFromProps={false}
                            />
                        </Grid>

                    </Grid>
                </DialogContent>

                <Divider />

                <DialogActions sx={{ py: 2, px: 3, justifyContent: "space-between" }}>
                    <Button onClick={onClose} variant="contained" color="error">
                        Ακύρωση
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit(onSubmitForm)}
                    >
                        {isEdit ? "Αποθήκευση Αλλαγών" : "Αποθήκευση"}
                    </Button>
                </DialogActions>
            </FormProvider>
        </Dialog>
    );
};

export default ProgramPeriodDialog;
